@if (mainFilename$ | async; as mainFilename) {
  <rs-angebot
    *axLazyElement="'rs-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></rs-angebot>
}
